module.exports = "/static/fonts/OpenSans-LightItalic.eot";